import { useRoute } from 'vue-router';
import type { LocationQuery, RouteLocationRaw } from 'vue-router';

const METRIC_WINDOW_QUERY_KEYS = ['days', 'from', 'to'] as const;

/** Builds a branch detail location with only the active metric window carried over. */
export function buildBranchLocation(id: string, currentQuery: LocationQuery): RouteLocationRaw {
  const query: LocationQuery = {};
  for (const key of METRIC_WINDOW_QUERY_KEYS) {
    const value = currentQuery[key];
    if (value != null) query[key] = value;
  }

  if (Object.keys(query).length === 0) {
    return { name: 'branch', params: { id } };
  }
  return { name: 'branch', params: { id }, query };
}

export function useBranchNavigation() {
  const route = useRoute();

  function branchLocation(id: string): RouteLocationRaw {
    return buildBranchLocation(id, route.query);
  }

  return { branchLocation };
}
